import { changesSince } from "routes/timeline/controller/changes-since"
import { Grid, Skeleton, Typography } from "@mui/material"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget"
import { navigate } from "lib/routes/navigate"

export function TimelineWidget() {
    const sixMonths = Date.create().beginningOfDay().addMonths(-6).toISOString()
    const threeMonths = Date.create().beginningOfDay().addMonths(-3).toISOString()
    const twelveMonths = Date.create().beginningOfDay().addMonths(-12).toISOString()

    const yearChanges = changesSince.useResults({ from: twelveMonths, summaryOnly: true }) ?? null
    const sixMonthChanges = changesSince.useResults({ from: sixMonths, summaryOnly: true }) ?? null
    const threeMonthChanges = changesSince.useResults({ from: threeMonths, summaryOnly: true }) ?? null

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="subtitle2">Schedule Changes</Typography>
            </Grid>
            {threeMonthChanges ? (
                <Grid item xs={12} sm={6} md={4}>
                    <AppWidget
                        data-cy="widget-3m"
                        component="button"
                        onClick={go(threeMonths)}
                        sx={{ cursor: "pointer" }}
                        title="in last 3 months"
                        color="#2f3998"
                        total={
                            <>
                                {threeMonthChanges.inUseSchedules ?? 0} in use{" "}
                                <Typography color="text.secondary" variant="caption">
                                    ({threeMonthChanges.totalSchedules} total)
                                </Typography>
                            </>
                        }
                        chartData={{
                            series: [percentInUse(threeMonthChanges)],
                        }}
                    />
                </Grid>
            ) : (
                <Grid item xs={12} sm={6} md={4}>
                    <Skeleton animation="wave" sx={{ height: 135 }} />
                </Grid>
            )}
            {sixMonthChanges ? (
                <Grid item xs={12} sm={6} md={4}>
                    <AppWidget
                        onClick={go(sixMonths)}
                        component="button"
                        sx={{ cursor: "pointer" }}
                        title="in last 6 months"
                        color="#5f51b8"
                        total={
                            <>
                                {sixMonthChanges.inUseSchedules ?? 0} in use{" "}
                                <Typography color="text.secondary" variant="caption">
                                    ({sixMonthChanges.totalSchedules} total)
                                </Typography>
                            </>
                        }
                        chartData={{
                            series: [percentInUse(sixMonthChanges)],
                        }}
                        data-cy="timeline-last-6-months-button"
                    />
                </Grid>
            ) : (
                <Grid item xs={12} sm={6} md={4}>
                    <Skeleton animation="wave" sx={{ height: 135 }} />
                </Grid>
            )}
            {yearChanges ? (
                <Grid item xs={12} md={4}>
                    <AppWidget
                        onClick={go(twelveMonths)}
                        data-cy="timeline-last-year-button"
                        component="button"
                        sx={{ cursor: "pointer" }}
                        title="in last year"
                        color="#5371d8"
                        total={
                            <>
                                {yearChanges.inUseSchedules ?? 0} in use{" "}
                                <Typography color="text.secondary" variant="caption">
                                    ({yearChanges.totalSchedules} total)
                                </Typography>
                            </>
                        }
                        chartData={{
                            series: [percentInUse(yearChanges)],
                        }}
                    />
                </Grid>
            ) : (
                <Grid item xs={12} md={4}>
                    <Skeleton animation="wave" sx={{ height: 135 }} />
                </Grid>
            )}
        </>
    )

    function go(time) {
        return function relocate() {
            navigate(`/app/timeline/${time}`)
        }
    }

    // Ring shows the share of the period's changed schedules that are in the user's
    // regimes, matching the "X in use (Y total)" text on the card. The previous
    // calculation divided by a client-side tree index count that isn't reliably
    // populated on the Home page, producing percentages far above 100% (FIQ-1018).
    function percentInUse(changes) {
        if (!changes.totalSchedules) return 0
        return Math.floor(((changes.inUseSchedules ?? 0) / changes.totalSchedules) * 100)
    }
}
